import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, IconButton, Icon, Typography, TextField, AppBar, Card, Divider } from '@material-ui/core';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const allViews = ["month", "day"]

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            padding: '4px 8px',
            border: '2px solid black',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-event-label': {
            display: 'none'
        },
        '& .rbc-day-slot .rbc-event': {
            minHeight: '30px'
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        }


    },
    addButton: {
        display: 'none'
    }

});

class DetailCalendar extends Component {

    state = {
        currentView: 'month',
        date: new Date(),
    }

    onNavigate = (event) => {
        const beginningMonth = this.state.date.getMonth()
        this.setState({ date: event })
        if (event.getMonth() === beginningMonth) {
            this.props.getDayEvents(this.props.object_id, moment(new Date(event)).format('YYYY-MM-DD'))
        }
        else {
            this.props.getSchedule(this.props.object_id, event)
            this.props.getDayEvents(this.props.object_id, moment(new Date(event)).format('YYYY-MM-DD'))
        }
    }

    selectSlot = (slotInfo) => {
        this.props.getDayEvents(this.props.object_id, moment(new Date(slotInfo.start)).format('YYYY-MM-DD'))
        this.setState({ date: slotInfo.start, currentView: 'day' })
    }

    onView = (view) => {
        this.state.currentView === 'month' ? this.setState({ currentView: 'day' }) : this.setState({ currentView: 'month' })
        this.props.getDayEvents(this.props.object_id, moment(new Date(this.state.date)).format('YYYY-MM-DD'))
    }


    eventStyleGetter = (event, start, end, isSelected) => {
        switch (event.eventType) {
            case ('fullCourse'): {
                let style = { backgroundColor: event.selected ? 'green' : event.color, color: this.props.theme.palette.getContrastText(event.color) }
                return { style: style }
            }
            case ('fullModule'): {
                let style = { backgroundColor: event.selected ? '#B10DC9' : '#0074D9', color: this.props.theme.palette.getContrastText(event.color) }
                return { style: style }
            }
            case ('fullLesson'): {
                let style = { backgroundColor: event.selected ? '#01FF70' : '#FF851B', color: this.props.theme.palette.getContrastText(event.color) }
                return { style: style }
            }
            case ('dayEventQuiz'): {
                let style = { backgroundColor: event.selected ? '#001f3f' : '#FF851B'}
                return { style: style }
            }
            case ('dayEventAssignment'): {
                let style = { backgroundColor: event.Color, color: this.props.theme.palette.getContrastText(event.Color) }
                return { style: style }
            }
            case ('existingEventCourse'): {
                let style = { backgroundColor: event.color }
                return { style: style }
            }
            case ('existingEventLesson'): {
                let style = { backgroundColor: '#FF851B' }
                return { style: style }
            }
            default: {
                let style = { backgroundColor: event.selected ? 'green' : '' }
                return { style: style }
            }
        }
    }

    render() {
        const { classes, events, dayEvents } = this.props
        console.log(events)
        const fullDayComponent = ({ event }) => (
            <div>
                <div style={{ fontSize: '12px' }} >{event.title} </div>
                <div style={{ fontSize: '10px' }} >{event.courseName} </div>
            </div>
        )

        const dayComponent = ({ event }) => (
            <div>

                <div className='float-left' style={{ paddingTop: '4px' }}>
                    {moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}
                </div>

                <div className='float-right'>
                    {event.title}
                </div>

            </div>
        )

        const unscheduledEvents = dayEvents.filter(e => e.Unscheduled === 1).map(event => {
            return (
                <tr>
                    <td>{event.title}</td>
                    <td>{event.title}</td>
                </tr>
            )
        })

        const todo_card = () => {
            if (this.state.currentView === 'day') {
                return (
                    <Card className={classNames(classes.root, "w-full")}>
                        <AppBar position="static">
    
                            <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                <Typography className="h1 pr-16" color="inherit">Unscheduled ToDos</Typography>
                            </div>
                        </AppBar>
                        <table className="simple">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Type</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unscheduledEvents}
                            </tbody>
                        </table>
    
                        <Divider className="card-divider w-full" />
                    </Card>
                )
            }
        return null
        }


        return (
            <div className={classes.root}>
                <Grid container spacing={24}>
                    <Grid item xs={9} style={{ width: '97%' }}>
                        <BigCalendar
                            popup
                            selectable
                            view={this.state.currentView}
                            // resizable
                            // onEventResize={this.resizeEvent}
                            className="flex flex-1"
                            events={this.state.currentView === 'month' ? events : dayEvents}
                            views={allViews}
                            showMultiDayTimes
                            defaultDate={new Date()}
                            defaultView="month"
                            onSelectSlot={(slotInfo) => this.selectSlot(slotInfo)}
                            date={this.state.date}
                            onNavigate={(event) => this.onNavigate(event)}
                            eventPropGetter={(this.eventStyleGetter)}
                            components={{ event: fullDayComponent, day: { event: dayComponent } }}
                            onView={(view) => this.onView(view)}
                            min={new Date(moment().startOf('day').add(6, 'hours'))}
                            max={new Date(moment().startOf('day').add(20, 'hours'))}
                            step={30}
                            onSelectEvent={event => {
                                // console.log(event)
                            }}
                        />

                    </Grid>
                    <Grid item xs={3}>
                        {todo_card()}
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ }) {
    return {
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(DetailCalendar)));


// WEBPACK FOOTER //
// src/main/components/DetailCalendar.js